const ossUrl = 'https://zy-web.oss-cn-beijing.aliyuncs.com'
export {
    ossUrl
}


// WEBPACK FOOTER //
// ./src/utils/config.js